"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getDeviceTransactionConfig = void 0;
var deviceTransactionConfig_1 = __importDefault(require("../generated/deviceTransactionConfig"));
var account_1 = require("../account");
function getDeviceTransactionConfig(arg) {
    var mainAccount = (0, account_1.getMainAccount)(arg.account, arg.parentAccount);
    var f = deviceTransactionConfig_1["default"][mainAccount.currency.family];
    if (!f)
        return [];
    return f(arg);
}
exports.getDeviceTransactionConfig = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map